import { render, staticRenderFns } from "./Disponibilidade4.vue?vue&type=template&id=969fc854&scoped=true&"
import script from "./Disponibilidade4.vue?vue&type=script&lang=js&"
export * from "./Disponibilidade4.vue?vue&type=script&lang=js&"
import style0 from "./Disponibilidade4.vue?vue&type=style&index=0&id=969fc854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969fc854",
  null
  
)

export default component.exports